/**
 * Scellement cryptographique d’une période comptable (A-23).
 * Le sceau est un hash SHA-256 des écritures triées — toute altération après clôture
 * est détectable via `verifierSceau`.
 */
export type EcriturePourSceau = {
  id: string;
  periode: string;
  compte: string;
  debit: number;
  credit: number;
  libelle: string;
  date: string;
  numero_piece?: string;
};

export function payloadSceau(ecritures: readonly EcriturePourSceau[]): string {
  return [...ecritures]
    .sort((a, b) => a.id.localeCompare(b.id))
    .map(
      (e) =>
        `${e.id}|${e.periode}|${e.date}|${e.compte}|${e.debit}|${e.credit}|${e.libelle}|${e.numero_piece ?? ''}`,
    )
    .join('\n');
}

export async function calculerSceauPeriode(
  ecritures: readonly EcriturePourSceau[],
): Promise<string> {
  const data = new TextEncoder().encode(payloadSceau(ecritures));
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function verifierSceau(
  ecritures: readonly EcriturePourSceau[],
  sceauAttendu: string,
): Promise<boolean> {
  if (!sceauAttendu) return false;
  const actuel = await calculerSceauPeriode(ecritures);
  return actuel === sceauAttendu;
}
